import React from 'react';
import {Field, reduxForm} from 'redux-form';
import validate from '../../common/validate';
import RenderField from './RenderField';

const StudentForm = (props) => {
    const {handleSubmit, submitting} = props;
    return (
        <form onSubmit={handleSubmit}>
            <Field
              name="password"
              type="password"
              component={RenderField}
              label="Password"/>
            <button className="btn btn-primary" type="submit" disabled={submitting}>Change Password</button>
        </form>
    )
}

export default reduxForm({
    form: 'StudentForm',
    validate
})(StudentForm);



// WEBPACK FOOTER //
// ./src/components/profile/forms/StudentForm.js